import React, { useState } from "react";
import dynamic from "next/dynamic";
import { isMobileContext } from "../../contexts/isMobileContext";
import { useContext } from "react";
import { BASE_URL } from "../../utils/FetchData";
import Image from "next/legacy/image";
import FadeIn from "../Animations/FadeIn";
import ArrowsSpliting from "../Animations/ArrowsSpliting";
import Magnitizer from "../Animations/Magnitizer";

// eslint-disable-next-line react/display-name
const OurVideo = ({ ourCompany }) => {
	const [isPlaying, setIsPlaying] = useState(false);
	const { isMobile } = useContext(isMobileContext);
	const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });
	const handlePlayVideo = () => {
		setIsPlaying(!isPlaying);
	};

	return (
		<div className="construction-updates-section our-video-section our-company" id="our-company">
			<div className="header" style={{ display: isPlaying ? "none" : "flex" }}>
				<FadeIn>
					<div className="slogan _eleX">{ourCompany?.sub_title}</div>
				</FadeIn>
				<FadeIn>
					<h2 className="light title _eleX">{ourCompany?.title}</h2>
				</FadeIn>
				{!isMobile &&
					<FadeIn>
						<p className="_eleX">{ourCompany?.description}</p>
					</FadeIn>
				}
			</div>
			<div className="container">
				<div
					className={`overlay ${isPlaying ? "hide-overlay" : ""}`}>
					{ourCompany && <Image
						src={`${BASE_URL}${isMobile ? ourCompany?.img_mobile.data.attributes.url : ourCompany?.img_desktop.data.attributes.url}`}
						alt={ourCompany?.img_mobile.data.attributes.url}
						layout="fill"
						objectPosition={"top"}
						objectFit="cover"
					/>}
					<div className="overlay-bg"></div>
				</div>
				<div className="icon-shadow-container">
					<Magnitizer
						customClass={`icon ${isPlaying ? "isPlaying" : ""}`}
						dataDest={1.5}
						onClick={() => {
							handlePlayVideo();
						}}
					>
						<div className="player-container" onClick={() => {
							handlePlayVideo();
						}}>
							<ArrowsSpliting xValue={"30%"}>
								{isPlaying ?
									<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
										<path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z" />
									</svg>
									:

									<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" >
										<path d="M23 12l-22 12v-24l22 12zm-21 10.315l18.912-10.315-18.912-10.315v20.63z" />
									</svg>
								}
							</ArrowsSpliting>
						</div>
					</Magnitizer>
				</div>

				{ourCompany && <div className="video-container">
					<ReactPlayer
						className="video-player"
						playing={isPlaying ? true : false}
						url={ourCompany?.youtube_url}
						width={"100%"}
						height={"100%"}
						playsinline={true}
						controls={true}
					/>
				</div>}
			</div>
		</div>
	);
};
export default OurVideo;
